export const NOTIFICATIONS_PATHS = {
  notifications: 'notifications',
};
